import React from 'react';
import PropTypes from 'prop-types';
import ListItemIcon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemIcon';
import Tooltip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Tooltip';
import TooltipInfoList from 'Components/ComponentLibrary/Components/Uncategorized/TooltipInfoList';
import InfoIcon from '@material-ui/icons/Info';
import ErrorIcon from 'Components/ComponentLibrary/Components/Uncategorized/Icons/ErrorIcon';
import WarningIcon from 'Components/ComponentLibrary/Components/Uncategorized/Icons/WarningIcon';

const ItemIcon = ({ resource }) => {
  const errors = resource.attr('errors') || [];
  const warnings = resource.attr('warnings') || [];
  const isPlaceholder = resource.isTruthy('isPlaceholder');

  if (errors.length) {
    return (
      <Tooltip
        title={
          <TooltipInfoList
            items={errors}
          />
          }
      >
        <ListItemIcon>
          <ErrorIcon />
        </ListItemIcon>
      </Tooltip>
    );
  }

  if (warnings.length) {
    return (
      <Tooltip
        title={
          <TooltipInfoList
            items={warnings}
          />
          }
      >
        <ListItemIcon>
          <WarningIcon />
        </ListItemIcon>
      </Tooltip>
    );
  }

  if (isPlaceholder) {
    return (
      <ListItemIcon>
        <Tooltip
          title={'Placeholder Account'}
        >
          <InfoIcon color={'primary'} />
        </Tooltip>
      </ListItemIcon>
    );
  }

  return null;
};

ItemIcon.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default ItemIcon;
